<section (scroll)="global.mainScroll($event)" class="mainScrollable scrollable">
  <div class="sd-container">

    <div class="row" *ngIf="!selectedSong">
      <div class="col-12">
        <div style="font-size:11px;line-height:16.5px;font-weight:400;font-family:Poppins;color:#989AA3 !important;"
          class="breadcrumbfont">
          <sd-breadcrumb [data]="{'breadcrumb':[{'name':'My Release'}], 'version':2}"></sd-breadcrumb>
          <sd-content-banner class="block m-t-20"></sd-content-banner>
        </div>
      </div>

    </div>


    <ng-container *ngIf="songsLoaded; else loader">
      <sd-releases-list *ngIf="!selectedSong" [songs]="songList" [totalCount]="totalCount"
        [moreLoading]="moreSongsLoading" (onSelect)="onSelectRelease($event)" (onDelete)="onDeleteRelease($event)"
        (onLoadMore)="getDistributedList(true)"></sd-releases-list>

      <sd-releases-detail *ngIf="selectedSong" [song]="selectedSong" (onBack)="onBackToList()"></sd-releases-detail>
    </ng-container>


    <ng-template #loader>
      <div class="releases-list-container">
        <div class="cards-list">
          <div *ngFor="let count of global.createRange(5)" class="release-card skeleton-card mb-3">
            <div class="row align-items-center">

              <div class="col-auto pr-0">
                <div class="skeletonLoading skeleton-artwork"></div>
              </div>


              <div class="col pl-3">
                <div class="skeletonLoading skeleton-badge mb-2"></div>
                <div class="skeletonLoading skeleton-title mb-2"></div>
                <div class="skeletonLoading skeleton-text w-50"></div>
              </div>


              <div class="col-auto text-right action-buttons-section d-none d-md-block">
                <div class="d-flex align-items-center justify-content-end">
                  <div class="skeletonLoading skeleton-button mr-3"></div>
                  <div class="skeletonLoading skeleton-button mr-3"></div>
                  <div class="skeletonLoading skeleton-button"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</section>